// extracted by mini-css-extract-plugin
export default {"MainDetail":"c7QTU"};